import * as React from "react";
import type { SVGProps } from "react";

export const BrazeOperatorWhiteSparkleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 26 25" {...props}>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.335 3.993v5M5.835 6.493h-5M20.96 17.77v5M23.46 20.27h-5"
    />
    <path
      fill="#fff"
      d="M5.794 14.452c.23-.444.345-.666.5-.738a.5.5 0 0 1 .423 0c.154.072.269.294.498.738l.35.674c.358.694.537 1.04.776 1.34q.32.402.736.711c.31.232.669.405 1.386.751l.628.304c.477.23.716.346.792.504a.5.5 0 0 1 0 .433c-.076.157-.315.273-.792.504l-.628.303c-.717.347-1.076.52-1.386.752a4 4 0 0 0-.736.71c-.24.3-.418.647-.777 1.34l-.349.674c-.23.444-.344.667-.498.739a.5.5 0 0 1-.424 0c-.154-.072-.269-.294-.499-.739l-.348-.674c-.359-.693-.538-1.04-.778-1.34a4 4 0 0 0-.735-.71c-.31-.232-.669-.405-1.386-.752l-.628-.303c-.478-.231-.716-.347-.792-.504a.5.5 0 0 1 0-.433c.076-.158.314-.273.792-.504l.628-.304c.717-.346 1.076-.52 1.386-.75q.416-.31.735-.712c.24-.3.42-.647.778-1.34z"
      opacity={0.9}
    />
    <path
      fill="#fff"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.214 2.029c.231-.583.347-.874.513-.96a.5.5 0 0 1 .46 0c.165.086.281.377.513.96l.848 2.131c.381.958.572 1.436.868 1.839.262.356.584.668.953.922.417.286.912.47 1.902.838l2.121.789c.623.231.935.347 1.024.516a.5.5 0 0 1 0 .467c-.089.169-.4.285-1.024.516l-2.121.789c-.99.368-1.485.552-1.902.838a4 4 0 0 0-.953.922c-.297.403-.487.881-.868 1.838l-.848 2.132c-.232.583-.348.874-.514.96a.5.5 0 0 1-.459 0c-.166-.086-.282-.377-.514-.96l-.848-2.131c-.38-.958-.57-1.436-.867-1.839a4 4 0 0 0-.954-.922c-.416-.286-.911-.47-1.901-.838l-2.121-.789c-.624-.231-.936-.347-1.025-.516a.5.5 0 0 1 0-.467c.09-.169.401-.285 1.025-.516l2.12-.789c.99-.368 1.486-.552 1.902-.838.37-.254.692-.566.954-.922.296-.403.487-.881.867-1.839z"
      opacity={0.9}
    />
  </svg>
);
